export const CountryList = [
  {
    name: "阿尔及利亚",
  },
  {
    name: "美属萨摩亚",
  },
  {
    name: "安道尔",
  },
  {
    name: "安哥拉",
  },
  {
    name: "安圭拉",
  },
  {
    name: "南极洲",
  },
  {
    name: "安提瓜和巴布达",
  },
  {
    name: "阿根廷",
  },
  {
    name: "亚美尼亚",
  },
  {
    name: "阿鲁巴",
  },
  {
    name: "澳大利亚",
  },
  {
    name: "奥地利",
  },
  {
    name: "阿塞拜疆",
  },
  {
    name: "巴哈马",
  },
  {
    name: "巴林",
  },
  {
    name: "孟加拉国",
  },
  {
    name: "巴巴多斯",
  },
  {
    name: "白俄罗斯",
  },
  {
    name: "比利时",
  },
  {
    name: "伯利兹",
  },
  {
    name: "贝宁",
  },
  {
    name: "百慕大",
  },
  {
    name: "不丹",
  },
  {
    name: "玻利维亚",
  },
  {
    name: "荷兰加勒比区",
  },
  {
    name: "波黑",
  },
  {
    name: "博茨瓦纳",
  },
  {
    name: "布韦岛",
  },
  {
    name: "巴西",
  },
  {
    name: "英属印度洋领地",
  },
  {
    name: "文莱",
  },
  {
    name: "保加利亚",
  },
  {
    name: "布基纳法索",
  },
  {
    name: "布隆迪",
  },
  {
    name: "佛得角",
  },
  {
    name: "柬埔寨",
  },
  {
    name: "喀麦隆",
  },
  {
    name: "加拿大",
  },
  {
    name: "开曼群岛",
  },
  {
    name: "中非",
  },
  {
    name: "乍得",
  },
  {
    name: "智利",
  },
  {
    name: "中国",
  },
  {
    name: "圣诞岛",
  },
  {
    name: "科科斯（基林）群岛",
  },
  {
    name: "哥伦比亚",
  },
  {
    name: "科摩罗",
  },
  {
    name: "刚果共和国",
  },
  {
    name: "刚果民主共和国",
  },
  {
    name: "库克群岛",
  },
  {
    name: "哥斯达黎加",
  },
  {
    name: "科特迪瓦",
  },
  {
    name: "克罗地亚",
  },
  {
    name: "古巴",
  },
  {
    name: "库拉索",
  },
  {
    name: "塞浦路斯",
  },
  {
    name: "捷克",
  },
  {
    name: "丹麦",
  },
  {
    name: "吉布提",
  },
  {
    name: "多米尼克",
  },
  {
    name: "多米尼加",
  },
  {
    name: "厄瓜多尔",
  },
  {
    name: "埃及",
  },
  {
    name: "萨尔瓦多",
  },
  {
    name: "赤道几内亚",
  },
  {
    name: "厄立特里亚",
  },
  {
    name: "爱沙尼亚",
  },
  {
    name: "斯威士兰",
  },
  {
    name: "埃塞俄比亚",
  },
  {
    name: "福克兰群岛",
  },
  {
    name: "法罗群岛",
  },
  {
    name: "斐济",
  },
  {
    name: "芬兰",
  },
  {
    name: "法国",
  },
  {
    name: "法属圭亚那",
  },
  {
    name: "法属波利尼西亚",
  },
  {
    name: "法属南部和南极领地",
  },
  {
    name: "加蓬",
  },
  {
    name: "冈比亚",
  },
  {
    name: "格鲁吉亚",
  },
  {
    name: "德国",
  },
  {
    name: "加纳",
  },
  {
    name: "直布罗陀",
  },
  {
    name: "希腊",
  },
  {
    name: "格陵兰",
  },
  {
    name: "格林纳达",
  },
  {
    name: "瓜德罗普",
  },
  {
    name: "关岛",
  },
  {
    name: "危地马拉",
  },
  {
    name: "根西",
  },
  {
    name: "几内亚",
  },
  {
    name: "几内亚比绍",
  },
  {
    name: "圭亚那",
  },
  {
    name: "海地",
  },
  {
    name: "赫德岛和麦克唐纳群岛",
  },
  {
    name: "梵蒂冈",
  },
  {
    name: "洪都拉斯",
  },
  {
    name: "香港",
  },
  {
    name: "匈牙利",
  },
  {
    name: "冰岛",
  },
  {
    name: "印度",
  },
  {
    name: "印度尼西亚",
  },
  {
    name: "伊朗",
  },
  {
    name: "伊拉克",
  },
  {
    name: "爱尔兰",
  },
  {
    name: "马恩岛",
  },
  {
    name: "以色列",
  },
  {
    name: "意大利",
  },
  {
    name: "牙买加",
  },
  {
    name: "日本",
  },
  {
    name: "泽西",
  },
  {
    name: "约旦",
  },
  {
    name: "哈萨克斯坦",
  },
  {
    name: "肯尼亚",
  },
  {
    name: "基里巴斯",
  },
  {
    name: "朝鲜",
  },
  {
    name: "韩国",
  },
  {
    name: "科威特",
  },
  {
    name: "吉尔吉斯斯坦",
  },
  {
    name: "老挝",
  },
  {
    name: "拉脱维亚",
  },
  {
    name: "黎巴嫩",
  },
  {
    name: "莱索托",
  },
  {
    name: "利比里亚",
  },
  {
    name: "利比亚",
  },
  {
    name: "列支敦士登",
  },
  {
    name: "立陶宛",
  },
  {
    name: "卢森堡",
  },
  {
    name: "澳门",
  },
  {
    name: "马达加斯加",
  },
  {
    name: "马拉维",
  },
  {
    name: "马来西亚",
  },
  {
    name: "马尔代夫",
  },
  {
    name: "马里",
  },
  {
    name: "马耳他",
  },
  {
    name: "马绍尔群岛",
  },
  {
    name: "马提尼克",
  },
  {
    name: "毛里塔尼亚",
  },
  {
    name: "毛里求斯",
  },
  {
    name: "马约特",
  },
  {
    name: "墨西哥",
  },
  {
    name: "密克罗尼西亚联邦",
  },
  {
    name: "摩尔多瓦",
  },
  {
    name: "摩纳哥",
  },
  {
    name: "蒙古国",
  },
  {
    name: "黑山",
  },
  {
    name: "蒙特塞拉特",
  },
  {
    name: "摩洛哥",
  },
  {
    name: "莫桑比克",
  },
  {
    name: "缅甸",
  },
  {
    name: "纳米比亚",
  },
  {
    name: "瑙鲁",
  },
  {
    name: "尼泊尔",
  },
  {
    name: "荷兰",
  },
  {
    name: "新喀里多尼亚",
  },
  {
    name: "新西兰",
  },
  {
    name: "尼加拉瓜",
  },
  {
    name: "尼日尔",
  },
  {
    name: "尼日利亚",
  },
  {
    name: "纽埃",
  },
  {
    name: "诺福克岛",
  },
  {
    name: "北马其顿",
  },
  {
    name: "北马里亚纳群岛",
  },
  {
    name: "挪威",
  },
  {
    name: "阿曼",
  },
  {
    name: "巴基斯坦",
  },
  {
    name: "帕劳",
  },
  {
    name: "巴勒斯坦",
  },
  {
    name: "巴拿马",
  },
  {
    name: "巴布亚新几内亚",
  },
  {
    name: "巴拉圭",
  },
  {
    name: "秘鲁",
  },
  {
    name: "菲律宾",
  },
  {
    name: "皮特凯恩群岛",
  },
  {
    name: "波兰",
  },
  {
    name: "葡萄牙",
  },
  {
    name: "波多黎各",
  },
  {
    name: "卡塔尔",
  },
  {
    name: "留尼汪",
  },
  {
    name: "罗马尼亚",
  },
  {
    name: "俄罗斯",
  },
  {
    name: "卢旺达",
  },
  {
    name: "圣巴泰勒米",
  },
  {
    name: "圣赫勒拿、阿森松和特里斯坦-达库尼亚",
  },
  {
    name: "圣基茨和尼维斯",
  },
  {
    name: "圣卢西亚",
  },
  {
    name: "法属圣马丁",
  },
  {
    name: "圣皮埃尔和密克隆",
  },
  {
    name: "圣文森特和格林纳丁斯",
  },
  {
    name: "萨摩亚",
  },
  {
    name: "圣马力诺",
  },
  {
    name: "圣多美和普林西比",
  },
  {
    name: "沙特阿拉伯",
  },
  {
    name: "塞内加尔",
  },
  {
    name: "塞尔维亚",
  },
  {
    name: "塞舌尔",
  },
  {
    name: "塞拉利昂",
  },
  {
    name: "新加坡",
  },
  {
    name: "荷属圣马丁",
  },
  {
    name: "斯洛伐克",
  },
  {
    name: "斯洛文尼亚",
  },
  {
    name: "所罗门群岛",
  },
  {
    name: "索马里",
  },
  {
    name: "南非",
  },
  {
    name: "南乔治亚和南桑威奇群岛",
  },
  {
    name: "南苏丹",
  },
  {
    name: "西班牙",
  },
  {
    name: "斯里兰卡",
  },
  {
    name: "苏丹",
  },
  {
    name: "苏里南",
  },
  {
    name: "斯瓦尔巴和扬马延",
  },
  {
    name: "瑞典",
  },
  {
    name: "瑞士",
  },
  {
    name: "叙利亚",
  },
  {
    name: "中国台湾省",
  },
  {
    name: "塔吉克斯坦",
  },
  {
    name: "坦桑尼亚",
  },
  {
    name: "泰国",
  },
  {
    name: "东帝汶",
  },
  {
    name: "多哥",
  },
  {
    name: "托克劳",
  },
  {
    name: "汤加",
  },
  {
    name: "特立尼达和多巴哥",
  },
  {
    name: "突尼斯",
  },
  {
    name: "土耳其",
  },
  {
    name: "土库曼斯坦",
  },
  {
    name: "特克斯和凯科斯群岛",
  },
  {
    name: "图瓦卢",
  },
  {
    name: "乌干达",
  },
  {
    name: "乌克兰",
  },
  {
    name: "阿联酋",
  },
  {
    name: "英国",
  },
  {
    name: "美国",
  },
  {
    name: "美国本土外小岛屿",
  },
  {
    name: "乌拉圭",
  },
  {
    name: "乌兹别克斯坦",
  },
  {
    name: "瓦努阿图",
  },
  {
    name: "委内瑞拉",
  },
  {
    name: "越南",
  },
  {
    name: "英属维尔京群岛",
  },
  {
    name: "美属维尔京群岛",
  },
  {
    name: "瓦利斯和富图纳",
  },
  {
    name: "西撒哈拉",
  },
  {
    name: "也门",
  },
  {
    name: "赞比亚",
  },
  {
    name: "津巴布韦",
  },
];
